import type {
  ApiLeaderboardPeriod,
  ApiLeaderboardResponse,
  RatingPeriodModel,
  RatingPeriodsModel,
} from '~/modules/main'

export const mapLeaderboardPeriodToRatingPeriod = (
  period?: ApiLeaderboardPeriod | null,
): RatingPeriodModel => ({
  from: period?.startDate ?? '',
  to: period?.endDate ?? '',
})

export const mapLeaderboardPeriodsToRatingPeriods = (
  response: Pick<ApiLeaderboardResponse, 'currentPeriod' | 'previousPeriod'>,
): RatingPeriodsModel => ({
  current: mapLeaderboardPeriodToRatingPeriod(response.currentPeriod),
  previous: mapLeaderboardPeriodToRatingPeriod(response.previousPeriod),
})
